module.exports = require("minimist");